function HamburgerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M22.625 12.375C22.625 12.6891 22.4986 12.9903 22.2735 13.2124C22.0485 13.4344 21.7433 13.5592 21.425 13.5592H3.825C3.50674 13.5592 3.20152 13.4344 2.97647 13.2124C2.75143 12.9903 2.625 12.6891 2.625 12.375C2.625 12.0609 2.75143 11.7597 2.97647 11.5376C3.20152 11.3156 3.50674 11.1908 3.825 11.1908H21.425C21.7433 11.1908 22.0485 11.3156 22.2735 11.5376C22.4986 11.7597 22.625 12.0609 22.625 12.375ZM3.825 7.24342H21.425C21.7433 7.24342 22.0485 7.11866 22.2735 6.89657C22.4986 6.67449 22.625 6.37328 22.625 6.05921C22.625 5.74514 22.4986 5.44393 22.2735 5.22185C22.0485 4.99976 21.7433 4.875 21.425 4.875H3.825C3.50674 4.875 3.20152 4.99976 2.97647 5.22185C2.75143 5.44393 2.625 5.74514 2.625 6.05921C2.625 6.37328 2.75143 6.67449 2.97647 6.89657C3.20152 7.11866 3.50674 7.24342 3.825 7.24342ZM21.425 17.5066H3.825C3.50674 17.5066 3.20152 17.6313 2.97647 17.8534C2.75143 18.0755 2.625 18.3767 2.625 18.6908C2.625 19.0049 2.75143 19.3061 2.97647 19.5282C3.20152 19.7502 3.50674 19.875 3.825 19.875H21.425C21.7433 19.875 22.0485 19.7502 22.2735 19.5282C22.4986 19.3061 22.625 19.0049 22.625 18.6908C22.625 18.3767 22.4986 18.0755 22.2735 17.8534C22.0485 17.6313 21.7433 17.5066 21.425 17.5066Z"
        fill="var(--purple-700)"
      />
    </svg>
  );
}

export default HamburgerIcon;
